export const nextFrame =
  typeof requestAnimationFrame === "function" ? requestAnimationFrame : (cb: () => void) => setTimeout(cb, 0);

export const nextNextFrame = (cb: () => void) => {
  nextFrame(() => nextFrame(cb));
};
